module.exports = __webpack_public_path__ + "static/moneyplant-c9d9582868481fc1427bc5757261e1c0.jpg";